import * as i0 from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseDialogIconComponent } from '@futura/futura-ui/dialog';
function DeleteDialogComponent_fut_base_dialog_icon_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const translate_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(translate_r1(ctx));
  }
}
function DeleteDialogComponent_fut_base_dialog_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fut-base-dialog-icon", 1);
    i0.ɵɵtemplate(1, DeleteDialogComponent_fut_base_dialog_icon_0_Conditional_1_Template, 3, 1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "button", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_5_0;
    const translate_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dialogIcon", ctx_r1.data.imgSrc || "/assets/futura-ui/image/emoji/TrashCan.svg")("dialogTitle", ctx_r1.data.title)("dialogSubtitle", ctx_r1.data.subtitle);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.data.content) ? 1 : -1, tmp_5_0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(translate_r1(ctx_r1.data.exitButton));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(translate_r1(ctx_r1.data.deleteButton));
  }
}
let DeleteDialogComponent = /*#__PURE__*/(() => {
  class DeleteDialogComponent {
    constructor(data) {
      this.data = data;
    }
    static {
      this.ɵfac = function DeleteDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeleteDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DeleteDialogComponent,
        selectors: [["fut-delete-dialog"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 0,
        consts: [[3, "dialogIcon", "dialogTitle", "dialogSubtitle", 4, "transloco"], [3, "dialogIcon", "dialogTitle", "dialogSubtitle"], [1, "text-center"], ["actions", "", 1, "d-flex", "justify-content-end", "align-items-center"], ["mat-dialog-close", "", 1, "fut-btn", "fut-btn-link", "fut-m-r-8"], ["mat-dialog-close", "true", 1, "fut-btn", "fut-btn-danger"]],
        template: function DeleteDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DeleteDialogComponent_fut_base_dialog_icon_0_Template, 7, 6, "fut-base-dialog-icon", 0);
          }
        },
        dependencies: [MatDialogClose, TranslocoDirective, BaseDialogIconComponent]
      });
    }
  }
  return DeleteDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DeleteDialogComponent };
